<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CreatePassThroughInvoice"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :resourceTitle="'Pass-through Invoice'|pgettext('Invoice')"
    :resourceKey="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="invoice"
      autofocus="first"
      v-if="loaded"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="client"
        :label="'Client'|pgettext('Invoice')"
        :labelAlign="labelAlign"
        labelColsMd="3"
        contentColsMd="9"
        :helpTooltip="'Specify the client to be re-invoiced.'|pgettext('CreatePassThroughInvoice|Tooltip')"
        required
      >
        <ItpFormSelect2
          name="client"
          v-model="item.client"
          :dataSource="b_7789867021953041_dataSource"
          valueField="id"
          textField="name"
          bind-object
          optionTemplate="<UcSuggestCompanyOption :option=option></UcSuggestCompanyOption>"
          use-option-template-for-selected-option
          required
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <ItpFormGroup
        name="ratio"
        :label="'Multiplier'|pgettext('CreatePassThroughInvoice')"
        :labelAlign="labelAlign"
        labelColsMd="3"
        contentColsMd="3"
        :helpTooltip="'Line items will be generated with the given multiplier.'|pgettext('CreatePassThroughInvoice|Tooltip')"
        required
      >
        <ItpFormInput
          type="number"
          name="ratio"
          v-model="item.ratio"
        >
        </ItpFormInput>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="forms.invoice"
      :text="'Create invoice'|pgettext('CreateInvoice|Submit')"
      type="submit"
      variant="primary"
      :spinning="actions.submit && actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CreatePassThroughInvoice extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  item!: any;

  async $$load_item() {
    return {
      invoice_type: 'pass_through',
      invoice_id: this.invoice.id,
      client: null,
      ratio: 1,
    }
  }

  labelAlign!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_7789867021953041_dataSource!: any;
  dataMembers = ['formId', 'item', 'labelAlign', 'ux', 'b_7315092382398562_modalBindings', 'b_7789867021953041_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        item: null,
        labelAlign: "right",
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
        b_7789867021953041_dataSource: {
          name: "suggest_company",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.$fn.pgettext("Invoice", "Create Invoice")
          ,
        this.invoice.invoice_number
          ,
        ]
        ,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3204_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3204, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_navigate_3210_getActionArgs($event: actions.ActionEvent): Promise<actions.NavigateActionArgs> {
    // parameterResolver name=act_1040167445267876_navigate_3210, alias=undefined
    return {
      location: {
        name: "app.invoice",
        params: {
          id: $event.data.response.data.id,
        }
        ,
      }
      ,
    }
  }

  async act_1040167445267876_request_3208_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_3208, alias=submit
    return {
      operation: "create_invoice",
      data: this.item,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_3214_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_3214, alias=undefined
    return {
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3204: actions.CloseModalAction;
    evh_7315092382398562_close_3203: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_3206: actions.CloseModalAction;
    evh_2248226175642056_close_3205: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_navigate_3210: actions.NavigateAction;
    evh_1040167445267876_success_3209: actions.EventHandlerImpl;
    act_1040167445267876_closeComponent_3212: actions.CloseComponentAction;
    evh_1040167445267876_success_3211: actions.EventHandlerImpl;
    act_1040167445267876_request_3208: actions.RequestAction;
    evh_1040167445267876_submit_3207: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_3214: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_3213: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3204 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3204_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3203 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3204,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3203],
      }
    );
    const act_2248226175642056_closeModal_3206 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3205 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_3206,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3205],
      }
    );
    const act_1040167445267876_navigate_3210 = new actions.NavigateAction(
      {
        actionArgs: this.act_1040167445267876_navigate_3210_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3209 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_navigate_3210,
        event: "success",
        displayName: "navigate",
      }
    );
    const act_1040167445267876_closeComponent_3212 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1040167445267876_success_3211 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_3212,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_request_3208 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_3208_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_success_3209, evh_1040167445267876_success_3211],
      }
    );
    const evh_1040167445267876_submit_3207 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_3208,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_3207],
      }
    );
    const act_1419464017721962_closeModal_3214 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_3214_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_3213 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_3214,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_3213],
      }
    );
    return {
      act_7315092382398562_closeModal_3204,
      evh_7315092382398562_close_3203,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_3206,
      evh_2248226175642056_close_3205,
      evh_2248226175642056_close,
      act_1040167445267876_navigate_3210,
      evh_1040167445267876_success_3209,
      act_1040167445267876_closeComponent_3212,
      evh_1040167445267876_success_3211,
      act_1040167445267876_request_3208,
      evh_1040167445267876_submit_3207,
      evh_1040167445267876_submit,
      act_1419464017721962_closeModal_3214,
      evh_1419464017721962_clickPreventStop_3213,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_request_3208,
    }
  }
}

Vue.component("CreatePassThroughInvoice", CreatePassThroughInvoice);

</script>